var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstHalfEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M400,710c169.28,0,310-140.41,310-310S568.98,90,399.7,90,90,230.72,90,400s140.41,310,310,310ZM320.37,509.71c-13.98,0-20.06-7.29-20.06-18.54v-182.05c0-10.94,6.08-18.54,20.06-18.54h27.66c13.98,0,20.06,7.6,20.06,18.54v182.05c0,11.25-6.08,18.54-20.06,18.54h-27.66ZM451.67,509.71c-13.68,0-20.36-7.29-20.36-18.54v-182.05c0-10.94,6.69-18.54,20.36-18.54h27.66c13.68,0,20.06,7.6,20.06,18.54v182.05c0,11.25-6.38,18.54-20.06,18.54h-27.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstHalfEnd);
export default __webpack_public_path__ + "static/media/first-half-end.1085cc18.svg";
export { ForwardRef as ReactComponent };